import { type FC } from 'preact/compat';

import clsx from 'clsx';

import { ReactComponent as Chevron } from '@/assets/images/icons/arrow-right.svg?react';
import { ReactComponent as InfoIcon } from '@/assets/images/icons/info.svg?react';

import { type Ad } from '../../model/wrapper-ads.types';

import s from './index.module.scss';

interface Props {
  ad: Ad;
  handleClick: () => void;
  className?: string;
}

export const AdCard: FC<Props> = ({ ad, handleClick, className }) => {
  const { title, description, advertiserInfo, image } = ad;

  return (
    <div className={clsx(s.container, className)}>
      <button onClick={handleClick} className={s.card}>
        <div className={s['image-block']}>
          <img className={s.image} src={image} alt="ad image" />
        </div>
        <div className={s['text-block']}>
          <div className={s.row}>
            <div className={s.title}>{title}</div>
            <div className={s.chip}>
              <span className={s['chip-text']}>Ad</span>
              <InfoIcon className={s['info-icon']} />
            </div>
          </div>
          <div className={s.row}>
            <div className={s.description}>{description}</div>
            <Chevron className={s.chevron} />
          </div>
          {advertiserInfo && <span className={s['legal-info']}>{advertiserInfo}</span>}
        </div>
      </button>
    </div>
  );
};
